import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {DocumentSelection, ServiceRequestStatus, userType} from '../../util/uiconstants';
import moment from 'moment';
import _ from 'lodash';
import utility from '../../util/utilityfunctions';

export default function serviceRequestsReducer(state = initialstate.serviceRequest, action) {
	switch (action.type) {
		case types.GET_ALL_TASKS:
			return {
				...state,
				selectedRows: []
			};

		case types.GET_ALL_SUGGESTED_TASKS:
			return {
				...state,
				suggestedTasks: action.response
			};

		case types.SELECT_LIST_ITEM_ROWS:
			if (action.payload.clearSelection) {
				let selectedItems = action.payload.items;
				return {
					...state,
					selectedRows: selectedItems
				};
			} else {
				if (action.payload.removeSelection) {
					let selectedRows = state.selectedRows.filter((item) => {
						return item.id != action.payload.item.id;
					});
					return {
						...state,
						selectedRows: [...selectedRows]
					};
				}

				return {
					...state,
					selectedRows: [...state.selectedRows, ...action.payload.items]
				};
			}
		case types.UPDATE_SERVICE_REQUEST_SELECTED_TASKS:
			if (action.payload.selected) {
				let taskExist = state.tasks.find((item) => {
					return item.id == action.payload.item.id;
				});

				if (!taskExist) {
					return {
						...state,
						tasks: [...state.tasks, action.payload.item],
						selectedRows: action.payload.selectRow ? [...state.selectedRows, action.payload.item] : state.selectedRows
					};
				}

				return state;
			} else {
				let tasks = state.tasks.filter((item) => {
					return item.id != action.payload.item.id;
				});
				return {
					...state,
					tasks: [...tasks],
					taskRemoved: true
				};
			}
		case types.RESET_SERVICE_REQUEST_DETAIL:
		case types.RESET_TASK_ATTRIBUTES:
			if (action && action.payload && action.payload.step == 4) {
				return state;
			}
			return initialstate.serviceRequest;
		case types.CONSTRUCT_EMPTY_SERVICE_REQUEST_WITH_SERVICE_OFFERING:
			return {
				...initialstate.serviceRequest,
				schedulerOfferingId: action.data.schedulerOfferingId,
				returnUrl: action.data.returnUrl,
				origin: action.data.origin
			};
		case types.UPDATE_SERVICE_REQUEST_SELECTED_ALL_TASKS:
			if (action.payload.selected) {
				let selectedTasksId = _.map(state.tasks, ({id}) => {
					return id;
				});
				let selectdItems = action.payload.items.filter((item) => {
					return !selectedTasksId.includes(item.id);
				});
				let selectedRowsId = _.map(state.selectedRows, ({id}) => {
					return id;
				});
				let selectdRows = action.payload.items.filter((item) => {
					return !selectedRowsId.includes(item.id);
				});
				let selectedRows = state.selectedRows;
				if (action.payload.clearSelection) {
					selectedRows = [];
				}

				let allSelectedTasks = [...state.tasks, ...selectdItems];
				selectedTasksId = _.map(allSelectedTasks, ({id}) => {
					return id;
				});

				return {
					...state,
					tasks: allSelectedTasks,
					selectedRows: action.payload.selectRow ? [...state.selectedRows, ...selectdRows] : selectedRows,
					suggestedTaskSelected: action.payload.suggestedTaskSelected
						? action.payload.suggestedTaskSelected
						: state.suggestedTaskSelected
				};
			} else {
				let selectedTasksId = _.map(action.payload.items, ({id}) => {
					return id;
				});
				let tasks = state.tasks.filter((item) => {
					return !selectedTasksId.includes(item.id);
				});
				return {
					...state,
					tasks: [...tasks],
					selectedRows: []
				};
			}
		case types.GET_ALL_TASKS_SERVICE_REQUEST:
			return {
				...state,
				taskList: action.response
			};

		case types.CLEAR_TASK_LIST_SERVICE_REQUEST:
			return {
				...state,
				taskList: {}
			};
		default:
			return state;
	}
}
